const PageNotFound = () =>{
    return(
        <>
        <div class="content-wrapper">

{/* <!-- Error  Section start --> */}
<div class="error-wrap ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 offset-lg-2">
                <div class="error-content">
                    <img src="assets/img/404.png" alt="Image"/>
                    <h2>Oops! Page Not Found</h2>
                    <p>The page you are looking for might have been removed had its name changed or is temporarily unavailable.</p>
                    <a href="/" class="btn style1">Back To Home</a>
                </div>
            </div>
        </div>
    </div>
</div>
{/* <!-- Error  Section end --> */}

</div>
        </>
    );
};
export default PageNotFound;